const tooltip = $(document).ready(function() {

    $('[data-toggle="tooltip"]').tooltip()

});

export { tooltip as default };
